import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../LoadingSpinner";
import Grid from "../Grid";
import ButtonRenderer from "../renderer/ButtonRenderer";
import {
  getBulkDropdownData,
  getDropdownData,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import {
  alertValidation,
  fleetAlertValidation,
} from "../validations/AlertCreation";
import Button from "../input/Button";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import { ResizableScrollingTextRenderer } from "../renderer/StyleRenderer";
import { AUTH_TYPES, FORMS, MODULES } from "../../const";
import { isNumber } from "../../helper";
import Modal from "../Modal";
import { AlertCircle, Check, X } from "react-feather";
import DeleteButtonRenderer from "../renderer/DeleteButtonRenderer";

const FORM = FORMS.COMMON.ALERTS.form;

const AlertForm = forwardRef(
  ({ opeType, dropdown, isLoading, currentValues, editMode, module }, ref) => {
    const [currentErrors, setCurrentErrors] = useState({});
    const [currentAlert, setCurrentAlert] = useState({});

    const [altCount, setAltCount] = useState(2);
    const [alerts, setAlerts] = useState([]);
    const [events, setEvents] = useState([]);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [alertTypeChange, setAlertTypeChange] = useState(false);
    const [deletedList, setDeletedList] = useState([]);

    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);

    const [alertData, setAlertData] = useState({
      altEvents: [],
      altDefaultTypes: [],
      altOperation: opeType,
      altCode: "",
      altReferance: "",
      altName: "",
      altType: "",
      altValue: "",
      altDescription: "",
      altStatus: 2,
      altActive: 1,
      altTypeValue: "",
    });

    console.log("currentValues", currentValues);

    useEffect(() => {
      (async () => {
        if (editMode && currentValues) {
          let currentAlerts = [];
          let currentEvent = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const mapAlertEvent = currentValue.altEvents.map(
              (alt) => alt.evnType,
            );
            let mapAlertDefaultType = [];
            if (currentValue.altDefaultTypes != null) {
              mapAlertDefaultType = currentValue.altDefaultTypes.map(
                (alt) => alt.evtType,
              );
            }
            currentAlerts.push({
              ...currentValue,
              altEvents: mapAlertEvent,
              altDefaultTypes: mapAlertDefaultType,
              id,
            });
            currentEvent.push({
              altEvents: currentValue.altEvents,
            });
            ++id;
          }
          setAltCount(id);
          setAlerts(currentAlerts);
          setEvents(currentEvent[0]);
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      (async () => {
        if (Object.keys(currentAlert).length > 0) {
          setAlertData({
            ...currentAlert,
            altTypeValue: "",
          });
        }
      })();
    }, [currentAlert]);

    const defaultTypeSelect = async (e, data) => {
      setAlertData((prev) => ({
        ...prev,
        altDefaultTypes: data.value,
      }));
    };

    useEffect(() => {
      (async () => {
        // setIsLoading(true);
        const { active } = await getBulkDropdownData([{ key: "active" }]);
        setActiveOptions(active);

        setAlertData({
          altEvents: [1],
        });
      })();
    }, []);

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            unmodified: [],
            created: [],
            deleted: deletedList,
          };

          alerts.forEach((alt) => {
            if (alt.altId && alt.altId !== null) {
              if (alt.modified) {
                updateState.modified.push(alt);
              } else {
                updateState.unmodified.push(alt);
              }
            } else {
              updateState.created.push(alt);
            }
          });

          return updateState;
        } else {
          return alerts;
        }
      },
      resetForm: () => {
        setButtonClicked(true);
        setAlerts([]);
      },
      // getEvent: () => {
      //   if (editMode) {
      //     let eventState = [];
      //     eventState.push(events.altEvents);
      //     return events.altEvents;
      //   }
      // },
      getEvent: () => {
        if (editMode && events && events.altEvents) {
          return events.altEvents;
        } else {
          return [];
        }
      },
    }));

    useEffect(() => {
      if (buttonClicked) {
        setAlertData({
          altDefaultTypes: [],
          altOperation: opeType,
          altEvents: [],
          altCode: "",
          altReferance: "",
          altName: "",
          altType: "",
          altValue: "",
          altDescription: "",
          altStatus: 2,
          altActive: 1,
          altTypeValue: "",
        });

        setButtonClicked(false);
        setCurrentAlert({});
      }
    }, [buttonClicked, opeType]);

    // useEffect(() => {
    //
    //   if (alertTypeChange){
    //     setAlertData({
    //       altValue: "",
    //       altDescription: "",
    //       altEvents: [],
    //       altStatus: 2,
    //       altActive: 1,
    //     });
    //     setAlertTypeChange(false);
    //   }
    // }, [alertTypeChange]);

    const eventFeatureSelect = async (e, data) => {
      setAlertData((prev) => ({
        ...prev,
        altEvents: data.value,
      }));
    };

    const onAddClick = async () => {
      setIsAddLoading(true);

      let alertErrors = null;
      if (opeType !== 16) {
        alertErrors = alertValidation({
          ...alertData,
        });
      } else {
        alertErrors = fleetAlertValidation({
          ...alertData,
        });
      }

      if (opeType === 16) {
        if (alertData.altDefaultTypes.length === 0) {
          alertErrors = {
            ...alertErrors,
            altDefaultTypes: "Please select at least one default type",
          };
        }
      }

      if (Object.keys(alertErrors).length === 0) {
        const altTypeValue = await getTextByValueAndKey(
          "alert_type",
          alertData.altType,
        );

        if (!alertData.altId || alertData.altId === null) {
          if (!alertData.id || alertData.id === null) {
            setAlerts((prevState) => [
              ...prevState,
              {
                ...alertData,
                id: altCount,
                altTypeValue,
              },
            ]);
            setAltCount((prevState) => ++prevState);
          } else {
            setAlerts((prevState) =>
              prevState.filter((item) => item.id !== alertData.id),
            );
            setAlerts((prevState) => [
              ...prevState,
              {
                ...alertData,
                altTypeValue,
              },
            ]);
          }
        } else {
          setAlerts((prevState) =>
            prevState.filter((item) => item.altId !== alertData.altId),
          );
          setAlerts((prevState) => [
            ...prevState,
            {
              ...alertData,
              altTypeValue,
              modified: true,
            },
          ]);
        }
        setButtonClicked(true);
        setIsAddLoading(false);
      }

      setCurrentErrors(alertErrors);
      setIsAddLoading(false);
      console.log("Alerts", alerts);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <form
              className="ui form"
              style={{ overflowY: "auto", height: "75vh" }}
            >
              <div className="ui segment">
                <h4 className="ui dividing header">Alert</h4>
                <div className="two fields">
                  <Input
                    label="Alert code"
                    error={currentErrors.altCode}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_code"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altCode: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    name="employeeCode"
                    value={alertData.altCode}
                    onChange={(e) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altCode: e.target.value,
                      }));
                    }}
                    disabled={true}
                  />
                  <Input
                    required={true}
                    label="Alert Name"
                    error={currentErrors.altName}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_name"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altName: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Alert Name"
                    name="reference"
                    value={alertData.altName}
                    onChange={(e) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altName: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    label="Alert Type"
                    error={currentErrors.altType}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_type"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altType: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    clearable
                    placeholder="Alert Type"
                    options={dropdown.altTypeOpt}
                    value={alertData.altType}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altType: data.value,
                        altValue: "",
                        altDescription: "",
                        altEvents: [],
                        altStatus: 2,
                        altActive: 1,
                      }));
                      setAlertTypeChange(true);
                    }}
                  />
                </div>
                <div className="field">
                  <Input
                    required={true}
                    label=" Values (Enter Values in Comma Separatly)"
                    error={currentErrors.altValue}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_value"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altValue: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Values"
                    name="values"
                    value={alertData.altValue}
                    onChange={(e) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altValue: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className="field">
                  {opeType !== 16 ? (
                    <Dropdown
                      label="Select Event"
                      required={true}
                      error={currentErrors.altEvents}
                      module={MODULES.Master}
                      form={`${FORM}_${opeType}`}
                      field="alt_events"
                      editMode={editMode}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { altEvents: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      clearable
                      multiple={true}
                      options={dropdown.altEventOpt}
                      placeholder="Select Events"
                      style={{ height: "fit-content" }}
                      value={alertData.altEvents}
                      onChange={eventFeatureSelect}
                    />
                  ) : (
                    <Dropdown
                      label="Default Types"
                      required={true}
                      error={currentErrors.altDefaultTypes}
                      module={MODULES.Master}
                      form={`${FORM}_${opeType}`}
                      field="alt_default_types"
                      editMode={editMode}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { altDefaultTypes: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      clearable
                      multiple={true}
                      options={dropdown.altDefaultTypeOpt}
                      placeholder="Select Default Type"
                      style={{ height: "fit-content" }}
                      value={alertData.altDefaultTypes}
                      onChange={defaultTypeSelect}
                    />
                  )}
                </div>
                <div className="field">
                  <Input
                    label="Description"
                    error={currentErrors.altDescription}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_description"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altDescription: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Description"
                    name="values"
                    value={alertData.altDescription}
                    onChange={(e) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altDescription: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    label="Status"
                    error={currentErrors.altStatus}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_status"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altStatus: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Status"
                    options={dropdown.altStatusOpt}
                    value={alertData.altStatus}
                    style={{ height: "20px" }}
                    onChange={(e, data) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altStatus: data.value,
                      }));
                    }}
                  />
                  {/* <Dropdown
                    required={true}
                    label="Active"
                    error={currentErrors.altActive}
                    module={MODULES.Master}
                    form={`${FORM}_${opeType}`}
                    field="alt_active"
                    authenticated={true}
                    needDeletePermission={true}
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { altActive: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Active"
                    options={dropdown.altActiveOpt}
                    value={alertData.altActive}
                    style={{ height: "20px" }}
                    onChange={(e, data) => {
                      setAlertData((prevState) => ({
                        ...prevState,
                        altActive: data.value,
                      }));
                    }}
                  /> */}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  authenticated={true}
                  editMode={editMode}
                  module={module}
                  form={`${FORM}_${opeType}`}
                  create={Object.keys(currentAlert).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <small style={{ color: "#9f3a38" }}>{`${
                currentErrors.mainCountError ? currentErrors.mainCountError : ""
              }`}</small>
              <Grid
                heading="Alert List"
                config={[
                  { headerName: "Type", field: "altTypeValue" },
                  {
                    headerName: "Value",
                    field: "altValue",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  { headerName: "Name", field: "altName" },
                  { headerName: "Description", field: "altDescription" },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        setCurrentAlert(params.data);
                      },
                      label: "Edit",
                      authenticated: true,
                      form: `${FORM}_${opeType}`,
                      module: module,
                      editMode: editMode,
                      consider: AUTH_TYPES.CREATE,
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.DELETE,
                      clickHandler: () => {
                        if (params.data.altId && params.data.altId !== null) {
                          setDeletedList((prevState) => [
                            ...prevState,
                            params.data.altId,
                          ]);
                        }
                        setAlerts((prevAlerts) =>
                          prevAlerts.filter(
                            (alert) => alert.id !== params.data.id,
                          ),
                        );
                      },
                      message:
                        "Are you sure you want to delete this Alert Form?",
                      label: "Delete",
                      className: "ui red button",
                      authenticated: true,
                      form: `${FORM}_${opeType}`,
                      module: module,
                      editMode:
                        params.data.altId !== null &&
                        isNumber(params.data.altId),
                    }),
                  },
                ]}
                content={alerts}
              />
            </form>
          </>
        )}
      </>
    );
  },
);

export default AlertForm;
